
import type { PropOptions } from 'vue';
import Vue from 'vue';
import CloseIcon from './images/close-icon.vue.svg';
import { sharingUrls, openShareWindow } from '@/components/utils/browser/socialSharing';
import WarRoomReferralLink from '@/components/partials/war-room/WarRoomReferralLink/WarRoomReferralLink.vue';

export default Vue.extend({
  name: 'WarRoomSharePopup',
  components: {
    CloseIcon,
    WarRoomReferralLink,
  },
  props: {
    sharableType: {
      type: String,
      default: '',
      required: true,
    } as PropOptions<string>,
    sharableUrl: {
      type: String,
      default: '',
      required: true,
    } as PropOptions<string>,
    sharableId: {
      type: Number,
      default: null,
      required: true,
    } as PropOptions<number>,
  },
  computed: {
    buttons() {
      return sharingUrls.map(socialNetwork => {
        const url = `${socialNetwork.url}${this.sharableUrl}`;

        // eslint-disable-next-line @typescript-eslint/no-var-requires
        return { ...socialNetwork, icon: require(`./images/${socialNetwork.name}-logo.vue.svg`) as string, url };
      });
    },
  },
  methods: {
    share(url: string, name: string): void {
      this.$analytics.logEvent(`war-room__post__share-button__click`, {
        objectType: this.sharableType,
        socialNetwork: name,
        objectId: this.sharableId,
      });

      openShareWindow(url, name);
    },
    handleReferralLinkClick() {
      this.$analytics.logEvent(`war-room__post__share-popup-referral-link__click`, {
        objectType: this.sharableType,
        objectId: this.sharableId,
      });
    },
  },
});
